import { Loader2, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

interface SlowLoadingNoticeProps {
  onReload: () => void;
  message?: string;
}

/**
 * Inline notice rendered alongside a loading skeleton when a query has been
 * pending longer than expected. Offers a Reload button that calls the parent's
 * refetch handler. Pair with `useSlowLoadingFlag` to gate visibility.
 */
export function SlowLoadingNotice({
  onReload,
  message = "This is taking longer than expected.",
}: SlowLoadingNoticeProps) {
  return (
    <Card className="border-amber-200 bg-amber-50">
      <CardContent className="pt-6 flex items-center justify-between gap-4 flex-wrap">
        <div className="flex items-center gap-2 text-amber-900">
          <Loader2 className="h-4 w-4 animate-spin" />
          <span className="text-sm">{message}</span>
        </div>
        <Button variant="outline" size="sm" onClick={onReload}>
          <RefreshCw className="h-4 w-4 mr-2" />
          Reload
        </Button>
      </CardContent>
    </Card>
  );
}
